import { IonList, IonListHeader } from "@ionic/react";
import { useBotsStore } from "../stores/bots.store";
import TradeListItem from "./TradeListItem";

interface Props {
  botId: string;
}

const TradeList: React.FC<Props> = ({ botId }) => {
  const trades = useBotsStore(
    state => state.bots.find(b => b.id === botId)?.data?.trades
  );

  let tradesMapped =
    trades && Object.entries(trades).map(([key, value]) => value);
  let openTrades = tradesMapped?.filter(
    (trade: any) => trade?.type !== "topup" && !trade?.sell
  );
  openTrades = openTrades?.sort(
    (a: any, b: any) => b.buy.dateClosed - a.buy.dateClosed
  );
  let historicalTrades = tradesMapped?.filter(
    (trade: any) => trade?.type === "topup" || trade?.sell
  );
  historicalTrades = historicalTrades?.sort(
    (a: any, b: any) => b.buy?.dateClosed - a.buy?.dateClosed
  );

  return (
    <IonList className="bg-primary-90 max-w-xl mx-auto">
      {openTrades?.length > 0 && (
        <IonListHeader className="pt-2">Open Trades</IonListHeader>
      )}
      {openTrades?.map((trade: any, index: number) => (
        <TradeListItem
          key={`${trade.id}-${index}`}
          trade={trade}
          botId={botId}
          navigate
        />
      ))}
      {historicalTrades?.length > 0 && (
        <IonListHeader className="pt-2">Historical Trades</IonListHeader>
      )}
      {historicalTrades?.map((trade: any, index: number) => (
        <TradeListItem
          key={`${trade.id}-${index}`}
          trade={trade}
          botId={botId}
        />
      ))}
    </IonList>
  );
};

export default TradeList;
